import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateLaunchDarklyFlag } from 'api/admin/businesses/businesses';

interface UseSaveFeatureFlagValueParams {
  setError: (error: string | null) => void;
  setLocalFlagStates: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
}

export const useSaveFeatureFlagValue = ({
  setError,
  setLocalFlagStates,
}: UseSaveFeatureFlagValueParams) => {
  const queryClient = useQueryClient();

  return useMutation<
    unknown,
    { response?: { data?: { error?: string } } },
    { flagKey: string; value: boolean; businessId: number }
  >({
    mutationFn: ({ flagKey, value, businessId }) => {
      return updateLaunchDarklyFlag({
        businessId,
        flagKey,
        value,
      });
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['getFeatureFlagsForBusiness', { businessId: variables.businessId }],
      });
      setError(null);
    },
    onError: (error, variables) => {
      setError(error?.response?.data?.error ?? 'Failed to update feature flag');
      // Revert local state on error by deleting the key
      setLocalFlagStates((prev) => {
        const newState = { ...prev };
        delete newState[variables.flagKey];
        return newState;
      });
    },
  });
};
